import axios from "axios";

export const newInvoiceRequest = async (body) => {
  const data = JSON.stringify(body);
  const url = window.location.hostname.includes('localhost')  ? 'localhost' : 'unioninformatica.org';
debugger;
  const config = {
    method: "POST",
    url: `http://${url}:4000/api/v1/boletaDigital/newInvoiceRequest`,
    //url: "http://localhost:4000/api/v1/boletaDigital/newInvoiceRequest",
    headers: {
      "Content-Type": "application/json",
    },
    data: data,
  };

  try {
    const response = axios(config);
    return await response;
  } catch (error) {
    const { response } = error;
    return await response;
  }
};
